import React from 'react';
import { Icon } from 'ui';

const BoostrapTooltip = props => (
  <span
    className={props.className}
    data-container="body"
    data-toggle="tooltip"
    title={props.tooltip}
    data-placement={props.dataPlacement}
  >
    <Icon name={props.iconName} className={`c-p ${props.iconClasses}`} />
  </span>
);

export default BoostrapTooltip;
